// extracted by mini-css-extract-plugin
export default {"providerAccountsContainer":"providerAccountsContainer-iZ5vXsAj"};